import {
  Box,
  Button,
  ButtonGroup,
  IconButton,
  Stack,
  Typography
} from '@mui/material';
import { DateTime } from 'luxon';
import {
  CustomIcon,
  GanntChart
} from 'modules';
import { ITimelineDuration } from 'modules/components/layer16/GanntChart/GanntChart';
import React, { useState } from 'react';
import { theme } from 'theme';



export type ProjectGanntChartSectionProps = {};



/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ProjectGanntChartSectionProps) => {
  const [
    timelineStartDate,
    setTimelineStartDate
  ] = useState(DateTime.now());

  const [
    timelineViewWindow,
    setTimelineViewWindow
  ] = useState<ITimelineDuration>('MONTH');

  const handleNext = ({
    timelineViewWindow,
    direction
  }: {
    timelineViewWindow: ITimelineDuration;
    direction: 'INC' | 'DEC';
  }) => {
    if (timelineViewWindow === 'MONTH') {
      setTimelineStartDate((prev) => direction === 'INC'
        ? prev.plus({
          months: 1
        })
        : prev.minus({
          months: 1
        }));
    }
    if (timelineViewWindow === 'QUARTER') {
      setTimelineStartDate((prev) => direction === 'INC'
        ? prev.plus({
          quarters: 1
        })
        : prev.minus({
          quarters: 1
        }));
    }
    if (timelineViewWindow === 'YEAR') {
      setTimelineStartDate((prev) => direction === 'INC'
        ? prev.plus({
          years: 1
        })
        : prev.minus({
          years: 1
        }));
    }
  };

  return (
    <Box
      display='flex'
      flexDirection='column'
    >
      {/* GANNT CHART HEADER */}
      <Stack
        direction='row'
        justifyContent='space-around'
        alignContent='center'
      >
        <Stack
          flex='1 1 0'
          direction='row'
        >
          <IconButton
            onClick={() => {
              handleNext({
                timelineViewWindow, direction: 'DEC'
              });
            }}
          >
            <CustomIcon.large.FC
              stroke={theme.palette.primary.main}
              icon='LEFTARROW'
            />
          </IconButton>
          <Typography
            variant='activityHeader'
          >
            {__calculateLabel(timelineStartDate, timelineViewWindow)}
          </Typography>
          <IconButton
            onClick={() => {
              handleNext({
                timelineViewWindow, direction: 'INC'
              });
            }}
          >
            <CustomIcon.large.FC
              stroke={theme.palette.primary.main}
              icon='RIGHTARROW'
            />
          </IconButton>
        </Stack>


        <ButtonGroup>
          <Button
            variant={
              timelineViewWindow === 'MONTH'
                ? 'contained'
                : 'outlined'
            }
            onClick={() => {
              setTimelineViewWindow(() => 'MONTH');
            }}
          >
            Month
          </Button>
          <Button
            variant={
              timelineViewWindow === 'QUARTER'
                ? 'contained'
                : 'outlined'
            }
            onClick={() => {
              setTimelineViewWindow(() => 'QUARTER');
            }}
          >
            Quarter
          </Button>
          <Button
            variant={
              timelineViewWindow === 'YEAR'
                ? 'contained'
                : 'outlined'
            }
            onClick={() => {
              setTimelineViewWindow(() => 'YEAR');
            }}
          >
            Year
          </Button>
        </ButtonGroup>
        {/* <Button>
          Jump to date
        </Button> */}

      </Stack>
      <GanntChart.FC
        timelineStartDate={timelineStartDate}
        timelineTimeUnit={timelineViewWindow}
        // timelineDuration='MONTH'
      />
    </Box>
  );
};

function __calculateLabel(timelineStartDate: DateTime<true>, timelineViewWindow: ITimelineDuration): React.ReactNode {
  if (timelineViewWindow === 'MONTH') {
    return timelineStartDate.toFormat('LLLL yyyy');
  }
  if (timelineViewWindow === 'QUARTER') {
    const quarter = timelineStartDate.quarter;
    return `Q${quarter}-${timelineStartDate.year}`;
  }
  if (timelineViewWindow === 'YEAR') {
    return timelineStartDate.toFormat(`${timelineStartDate.year}`);
  }
}
